import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import amazonIcon from "../../../assets/images/amazon-ads.png"
import {APIClient} from "../../../helpers/ApiHelper";



export const getAllTargetAudience = createAsyncThunk(
    "getAllTargetAudience",
    async (_, thunkAPI) => {
        try {
            const apiClient = new APIClient();

            const response = await apiClient.get("/api/v1/management/audience/list?target=true");
            return response.data;
        } catch (error) {
            return [];
        }
    }
);


export const getAllTargetAudienceSlice = createSlice({
    name: "getAllTargetAudienceSlice",
    initialState: {
        loading: false,
        payload: [],
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getAllTargetAudience.pending, (state) => {
                state.loading = true;
                state.payload = [];
            })
            .addCase(getAllTargetAudience.fulfilled, (state, action) => {
                state.loading = false;
                state.payload = action.payload
            })
            .addCase(getAllTargetAudience.rejected, (state) => {
                state.loading = false;
            });
    },
});


export default getAllTargetAudienceSlice.reducer;